import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InvoiceFiltersSlidingPanel from './InvoiceFiltersSlidingPanel';
import {
  applyFilters,
  expandInvoiceFilter,
  clearInvoiceFilter,
  restoreInvoiceFilters,
  clearAllInvoiceFilters,
  setFilterValue,
  validateFilter,
  validateDateFilters
} from 'redux/invoiceFilters/InvoiceFiltersActions';

const mapStateToProps = ({ invoiceFilters }) => ({
  tempFilters: invoiceFilters.tempFilters
});

const mapDispatchToProps = dispatch => ({
  invoiceFiltersActions: bindActionCreators(
    {
      applyFilters,
      expandInvoiceFilter,
      clearInvoiceFilter,
      restoreInvoiceFilters,
      clearAllInvoiceFilters,
      setFilterValue,
      validateFilter,
      validateDateFilters
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceFiltersSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceFilters/InvoiceFiltersSlidingPanelConnector.js